module.exports = __webpack_public_path__ + "static/media/seamos-bosques.a9f214fc.png";